import { Service } from '@/services/Service';
import { RelatedPersonsService } from '@/services/relations/related-persons.service';
import { PersonsService } from '@/services/persons.service';
import relations from '@/services/relations/relations.service';

class PersonRelatedPersonsService extends Service {
  static entity(personId) {
    return `${PersonsService.entity}/${personId}/${RelatedPersonsService.entity}`;
  }
}

Object.assign(PersonRelatedPersonsService, relations);

export default PersonRelatedPersonsService;
